// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"38600b0f","455":"3b37999a","977":"240addac"}[chunkId] + ".chunk.js";
};